import { useMemo } from 'react';
import { MipClassifierRes } from '@dealstack/shared/lib/generated';
import { useMantineTableWithPaginationFilteringSorting } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting.ts';
import { getClassifiersTableColumns } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Classifiers/components/ClassifiersTable/getClassifiersTableColumns.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface ClassifierFilterDto {
	name?: string;
}

interface Props {
	onEdit: (classifier: MipClassifierRes) => void;
	onArchiveToggle: (classifier: MipClassifierRes) => void;
	onManageTags: (classifier: MipClassifierRes) => void;
	onRemoveTag: (cohortId: string, tagId: string) => void;
	canEdit: boolean;
	tagsByClassifierId: Record<string, { id: string; name: string }[]>;
}

export const useClassifiersTableState = ({
	onEdit,
	onArchiveToggle,
	onManageTags,
	onRemoveTag,
	canEdit,
	tagsByClassifierId,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const columns = useMemo(
		() =>
			getClassifiersTableColumns({
				handlers: { onEdit, onArchiveToggle, onManageTags, onRemoveTag },
				canEdit,
				tMipManage,
				tagsByClassifierId,
			}),
		[
			onEdit,
			onArchiveToggle,
			onManageTags,
			onRemoveTag,
			canEdit,
			tMipManage,
			tagsByClassifierId,
		]
	);

	const { mantineTableDataOperations } = useMantineTableWithPaginationFilteringSorting<
		MipClassifierRes,
		ClassifierFilterDto
	>(columns, {}, false);

	return {
		columns,
		mantineTableDataOperations,
	};
};
